import { render, staticRenderFns } from "./OnlineReservationSalesReport.vue?vue&type=template&id=707c6b52&scoped=true&"
import script from "./OnlineReservationSalesReport.vue?vue&type=script&lang=js&"
export * from "./OnlineReservationSalesReport.vue?vue&type=script&lang=js&"
import style0 from "./OnlineReservationSalesReport.vue?vue&type=style&index=0&id=707c6b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707c6b52",
  null
  
)

export default component.exports